import React from 'react'

interface Props { isActive?: boolean }

const VoiceActivityBars: React.FC<Props> = ({ isActive }) => {
  const config = { width: 'w-1.5', maxHeight: 24, minHeight: 6 }
  const color = 'bg-deep-green'
  const barClass = `${config.width} ${color} rounded-full transition-all duration-150 ease-in-out`
  return (
    <div className='flex items-end gap-1 h-8 pb-1'>
      {/* Bar 1 */}
      <div
        className={barClass}
        style={{
          height: isActive ? `${config.maxHeight * 0.6}px` : `${config.minHeight}px`,
          animation: isActive ? 'voiceBar1 0.8s ease-in-out infinite alternate' : 'none'
        }}
      />

      {/* Bar 2 */}
      <div
        className={barClass}
        style={{
          height: isActive ? `${config.maxHeight}px` : `${config.minHeight}px`,
          animation: isActive ? 'voiceBar2 0.8s ease-in-out 0.2s infinite alternate' : 'none',
        }}
      />

      {/* Bar 3 */}
      <div
        className={barClass}
        style={{
          height: isActive ? `${config.maxHeight * 0.8}px` : `${config.minHeight}px`,
          animation: isActive ? 'voiceBar3 0.9s ease-in-out 0.4s infinite alternate' : 'none',
        }}
      />

      <style>{`
        @keyframes voiceBar1 {
          0% { height: ${config.minHeight}px; }
          50% { height: ${config.maxHeight * 0.4}px; }
          100% { height: ${config.maxHeight * 0.6}px; }
        }

        @keyframes voiceBar2 {
          0% { height: ${config.maxHeight * 0.3}px; }
          50% { height: ${config.maxHeight}px; }
          100% { height: ${config.maxHeight * 0.5}px; }
        }

        @keyframes voiceBar3 {
          0% { height: ${config.minHeight}px; }
          50% { height: ${config.maxHeight * 0.6}px; }
          100% { height: ${config.maxHeight * 0.8}px; }
        }
      `}</style>
    </div>
  )
}

export default VoiceActivityBars
